<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-08-30 11:32:48
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-08-30 17:13:55
-->
<template>
  <div class="geography">
    <div style="width: 1280px; margin: 0 auto">
      <div>
        <div class="brand-title">
          <span class="title" @click="$router.push('/')">首页</span> >
          <span class="title">知识产权服务</span> >
          <span class="title">地理标识服务</span>
        </div>
      </div>

      <div class="search-box">
        <div class="result-list" style="width:1200px;">
          <div
            class="result-item"
            v-for="item in list"
            :key="item.id"
            style=" text-align:left;padding: 20px; align-items: center;display: flex;height: 200px;border-bottom: 2px solid #f2f2f2;"
          >
            <div class="avatar" style="  width: 220px;height: 140px;">
              <img
                :src="item.agencyzLogo ? item.agencyzLogo : defaultImg"
                style="width: 200px;"
              />
            </div>
            <div
              class="result-info"
              style=" width: 1300px;height: 140px;display: flex;padding-left:20px;flex-direction: column;justify-content: space-around;"
            >
              <div class="result-info-title">{{ item.name }}</div>
              <div
                class="result-info-content"
                style="width:100%;height:50px;padding-top:10px;display: flex;color: rgb(3, 2, 2);"
              >
                <div class="result-address" style="width: 800px;">
                  <span>联系电话：</span
                  ><span>{{
                    item.enterprisePhone
                      ? item.enterprisePhone.replace(
                          /(\d{3})(\d{4})(\d{4})/,
                          '$1****$3'
                        )
                      : ''
                  }}</span>
                  <span style=" margin-left: 20px">机构地址：</span
                  ><span v-if="item.address">{{
                    addressSubString(item.address)
                  }}</span>
                </div>
                <div
                  class="result-time"
                  style="width:210px;color: rgb(3, 2, 2);padding-left:10px;"
                >
                  <span
                    >入驻平台时间：{{ dateSubString(item.createTime) }}</span
                  >
                </div>
              </div>
              <div
                class="result-info-link"
                style="width:93%;height:50px;padding-top:10px;padding-bottom:10px"
                :title="item.enterpriseDesc"
              >
                <span v-if="item.enterpriseDesc">
                  企业简介：{{ remarkSubString(item.enterpriseDesc) }}</span
                >
              </div>
              <div class="company" style="padding-top:10px">
                <!-- <div>企业名称:</div> -->
                <a
                  class="concat-btn"
                  href="javascript:;"
                  @click="
                    () =>
                      $router.push({
                        path: '/GeographyDetail',
                        query: { id: item.id },
                      })
                  "
                  style="      margin-left: 77%;
                    border-radius: 8%;
                    color: #fff;
                    width: 160px;
                    height: 35px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #0599fb;
                    cursor: pointer;"
                  >查看企业</a
                >
              </div>
            </div>
          </div>
          <div class="result-item-page">
            <pagination :num="num" :limit="limit" @getNew="getNew"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '../util/request'
import pagination from '../components/pagination.vue'
const defaultImg = require('../assets/default.png')
export default {
  name: 'search',
  components: {
    pagination,
  },
  data() {
    return {
      pageIndex: 1,
      num: 0,
      limit: 8,
      defaultImg,
      data: new Array(5).fill({ title: '213' }),
      list: [],
    }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    getNew(pageOffset) {
      this.pageIndex = pageOffset
      this.list = this.queryList()
    },
    queryList() {
      request({
        url: '/api/client/common/enterprise/search',
        method: 'get',
        params: {
          type: 'ORG_OWNER',
          page: this.pageIndex,
          pageSize: this.limit,
        },
      }).then((res) => {
        if (res.code == '200') {
          this.list = res.data.records
          this.pageIndex = parseInt(res.data.current)
          this.num = parseInt(res.data.total)
          this.limit = parseInt(res.data.size)
        }
      })
    },
    //截取时间
    dateSubString(data) {
      return data.substring(0, 10)
    },
    //截取地址
    addressSubString(data) {
      return data.substring(0, 30)
    },
    //截取简介
    remarkSubString(data) {
      return data.substring(0, 150)
    },
    phoneNumFilter(phone) {
      // 1字符串转化成数组
      let phoneArr = [...phone]
      // 2.将数组中的4-7位变成*
      phoneArr.map((res, index) => {
        if (index > 2 && index < 7) {
          this.str += '*'
          // return '*';
        } else {
          this.str += res
          // return res;
        }
      })
      return this.str
    },
  },
}
</script>
<style lang="less">
.result-item-page {
  width: 97%;
  text-align: center;
  background: #fff;
  margin-left: 8px;
}
.brand-title {
  height: 44px;
  display: flex;
  background: #fff;
  align-items: center;
  border: 1px solid #ccc;
  .title {
    font-size: 14px;
    font-weight: bold;
  }
  span {
    padding: 10px;
  }
  .active {
    color: #1890ff;
  }
}
.geography {
  .result-list {
    background: #fff;
    display: block;
    .result-item {
      padding: 20px;
      align-items: center;
      display: flex;
      height: 200px;
      border-bottom: 2px solid #f2f2f2;
      .avatar {
        width: 220px;
        height: 140px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .result-info {
        width: 1200px;
        height: 140px;
        display: flex;
        padding-left: 20px;
        flex-direction: column;
        justify-content: space-around;
        .result-info-title {
          font-size: 18px;
          font-weight: bold;
        }
        .result-info-link {
          color: rgb(3, 2, 2);
        }
        .result-info-content {
          display: flex;
          color: rgb(3, 2, 2);
        }
        .result-address {
          width: 36%;
        }
        .result-time {
          padding-left: 400px;
          color: rgb(3, 2, 2);
        }
      }
      .company {
        padding-top: 0px;
        color: rgb(3, 2, 2);
        .concat-btn {
          margin-left: 77%;
          border-radius: 8%;
          color: #fff;
          width: 160px;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #0599fb;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
